import "core-js/modules/es.array.concat.js";
import i18n from 'i18n';
import formatHelixScore from './formatHelixScore';
import getHelixScoreBand from './getHelixScoreBand';

/**
 * A chart tooltip readout for Helix scores: "Sep 7: 4.2/5", plus the score's band word when
 * `bandOptions` has bands ("Sep 7: 4.2/5 · Developing"). A score normalised to its band's
 * position shows only the band's name ("Sep 7: Developing"), as the position is no score.
 * @param outOf - The scale the scores are out of
 * @param decimalPlaces - How many decimal places to show the scores to
 * @param bandOptions - The bands to name, and whether the scores are normalised to them
 * @returns The readout function the charts call for each point
 */
export default function getHelixGraphTooltip() {
  var outOf = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 100;
  var decimalPlaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var bandOptions = arguments.length > 2 ? arguments[2] : undefined;
  return function tooltipReadout(value, label) {
    if (value === null) {
      return "".concat(label, ": ").concat(i18n.t('skills_no_score'));
    }
    var band = bandOptions !== null && bandOptions !== void 0 && bandOptions.scoreBands.length ? getHelixScoreBand(value, bandOptions) : null;
    if (bandOptions !== null && bandOptions !== void 0 && bandOptions.normalised) {
      var _band$label;
      return "".concat(label, ": ").concat((_band$label = band === null || band === void 0 ? void 0 : band.label) !== null && _band$label !== void 0 ? _band$label : i18n.t('skills_no_score'));
    }
    var score = formatHelixScore(value, {
      outOf: outOf,
      decimalPlaces: decimalPlaces
    });
    return band ? "".concat(label, ": ").concat(score, " \xB7 ").concat(band.label) : "".concat(label, ": ").concat(score);
  };
}